class AbstractServiceConfiguration

  constructor: (service, $q) ->
    @service = service
    @q = $q

  getUrl: () ->
    @url || throw 'O parâmetro url não está configurado.'

  getId: (data) ->
    data = data?[@wrappedIn] if @wrappedIn
    data?[@idHolder || 'id']

  getCallFunction: () ->
    @callFunction ?= {}
    {method: @callFunction.method or 'GET', holder: @callFunction.holder or 'q'}

  mock: (config) ->
    # Faz um loop nas configurações para poder sobreescrever os métodos
    for method, resultCallback of config
      # Substitui o método atual na referência existente do service
      @service[method] = ((resultCallback, self) ->
        # Guarda os parâmetros passados para a chamada original
        (args...) ->
          # Cria um deferred para compatibilidade com estrutura atual de promises
          deferred = self.q.defer()
          # Extrai callback dos argumentos
          [_, callback, _] = self.service.getListArgs(args)
          # Utiliza setTimeout para simular um delay da conexão
          setTimeout(->
            # Resolve a promessa
            deferred.resolve()
            # Chama callback passando valor configurado como parâmetro
            callback(resultCallback(args...))
          , 500)
          # Retorna a promessa
          deferred.promise
      )(resultCallback, this)

class AbstractService
  @$inject = ['$injector', '$q', 'pathService', 'httpService']

  constructor: (injector, $q, @pathService, @httpService) ->
    @configs = new AbstractServiceConfiguration(this, $q)
    @configure(@configs, injector)

  configure: () -> throw "É preciso implementar o método configure."

  getListArgs: (args) ->
    if angular.isFunction args[0]
      [callback, options] = args
      [{}, callback, options]
    else
      args

  getList: (args...) ->
    [query, callback, options] = @getListArgs(args)

    @doRequest('GET', query, callback, options)

  get: (id, callback, options) -> @doRequest('GET', id, callback, options)
  delete: (id, callback, options) -> @doRequest('DELETE', id, callback, options)
  save: (data, callback, options) -> @doRequest((if @configs.getId(data) then 'PUT' else 'POST'), data, callback, options)

  callFunction: (id, data, callback, options) ->
    {method: method, holder: holder} = @configs.getCallFunction()

    data[holder] = id
    @doRequest(method, data, callback, options)

  doRequest: (method, data, callback, options = {}) ->
    request = {method: method, onSuccess: callback, screenId: '#content [ng-app]', url: @pathService.getApiUrl() + @configs.getUrl() + '/'}

    request = angular.extend(request, options)

    switch true
      when method in ['GET', 'DELETE'] and (angular.isString(data) or angular.isNumber(data))
        request.url += data

      when method in ['GET', 'DELETE'] and angular.isObject(data)
        request.url += @pathService.parametrize('', data)

      when method is 'PUT' and @configs.getId(data)?
        request.url += @configs.getId(data)
        request.data = data

      else
        request.data = data

    @httpService.request request

window.AbstractServiceConfiguration = AbstractServiceConfiguration
window.AbstractService = AbstractService
